if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      let hasError = false

      if (document.querySelector("variant-selects > div > div > select")) {
        const dropVal = document.querySelector("variant-selects > div > div > select").value;
        if (dropVal == "") {
          const variantValidation = document.querySelector("variant-selects .prod-validation");
          if (variantValidation && variantValidation.classList.contains('hidden')) {
            variantValidation.classList.remove('hidden');
          }

          const mobSelect = document.querySelector(".select-mob");
          if (mobSelect && !mobSelect.classList.contains('text-red-1')) {
            mobSelect.classList.add('text-red-1');
            setTimeout(function () {
              mobSelect.classList.add('pt-4');
            }, 200);
            setTimeout(function () {
              mobSelect.classList.remove('pt-4');
            }, 400);
            setTimeout(function () {
              mobSelect.classList.add('pb-4');
            }, 600);
            setTimeout(function () {
              mobSelect.classList.remove('pb-4');
            }, 800);
          }
          
          hasError = true
        }
      }

      // Initial dropdown validation
      if (document.querySelector('.product-form__initial-button')) {
        const initialDropdownValidation = document.querySelector('.product-form__initial .prod-validation');
        const initialDropdownProperty = document.querySelector('.product-form__initial-property');
        
        if (!initialDropdownProperty || initialDropdownProperty.value === "") {
          initialDropdownValidation.classList.remove('hidden');

          if (!initialDropdownValidation.classList.contains('text-red-1')) {
            initialDropdownValidation.classList.add('text-red-1');
            setTimeout(function () {
              initialDropdownValidation.classList.add('pt-4');
            }, 200);
            setTimeout(function () {
              initialDropdownValidation.classList.remove('pt-4');
            }, 400);
            setTimeout(function () {
              initialDropdownValidation.classList.add('pb-4');
            }, 600);
            setTimeout(function () {
              initialDropdownValidation.classList.remove('pb-4');
            }, 800);
          }
          
          hasError = true
        }
      }

      // Engraving module validation
      if (document.querySelector('.engraving-module')) {
        const engravingValidation = document.querySelector('.engraving-module__wrapper .prod-validation');
        const engravingInput = document.querySelector('.engraving-module__input');
        
        if (engravingInput && engravingValidation && engravingInput.value.trim() === "") {
          engravingValidation.classList.remove('hidden');

          if (!engravingValidation.classList.contains('text-red-1')) {
            engravingValidation.classList.add('text-red-1');
            setTimeout(function () {
              engravingValidation.classList.add('pt-4');
            }, 200);
            setTimeout(function () {
              engravingValidation.classList.remove('pt-4');
            }, 400);
            setTimeout(function () {
              engravingValidation.classList.add('pb-4');
            }, 600);
            setTimeout(function () {
              engravingValidation.classList.remove('pb-4');
            }, 800);
          }
          
          hasError = true
        }
      }

      const productTermsCheckboxes = Array.from(document.querySelectorAll('.product-terms__checkbox'))
      if (productTermsCheckboxes.length && !productTermsCheckboxes.some((checkbox) => checkbox.checked)) {
        const productTermsContainers = document.querySelectorAll('.product-terms')

        productTermsContainers.forEach((container) => container.classList.add('product-terms--has-error'))
        setTimeout(() => {
          productTermsContainers.forEach((container) => container.classList.remove('product-terms--has-error'))
        }, 2000)

        hasError = true
      }

      if (hasError) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        
        if (window.innerWidth < 850) {
          const firstError = document.querySelector('variant-selects .prod-validation:not(.hidden), .product-form__initial .prod-validation:not(.hidden), .engraving-module__wrapper .prod-validation:not(.hidden), .product-terms--has-error, .select-mob.text-red-1');
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        
        return false;
      }

      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      // Add external form elements that are linked via form attribute
      const formId = this.form.getAttribute('id');
      if (formId) {
        const externalElements = document.querySelectorAll(`[form="${formId}"]`);
        externalElements.forEach(element => {
          if (element.name && !this.form.contains(element)) {
            formData.append(element.name, element.value);
          }
        });
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// validation submit continued
const varDrop = document.querySelector("variant-selects > div > div > select");
if (varDrop) {
  varDrop.addEventListener("change", function () {
    var varValue = document.querySelector("variant-selects > div > div > select").value;
    const selectMob = document.querySelector(".select-mob");
    const variantValidation = document.querySelector("variant-selects .prod-validation");
    
    if (selectMob) selectMob.value = varValue;
    if (variantValidation) variantValidation.classList.add('hidden');
    if (selectMob) selectMob.classList.remove('text-red-1');
  });
}

const varDrop2 = document.querySelector(".select-mob");
if (varDrop2) {
  varDrop2.addEventListener("change", function () {
    const selectMob = document.querySelector(".select-mob");
    const variantValidation = document.querySelector("variant-selects .prod-validation");
    
    if (selectMob) selectMob.classList.remove('text-red-1');
    if (variantValidation) variantValidation.classList.add('hidden');
    
    var varValue = document.querySelector(".select-mob").value;
    const varSelect = document.querySelector("variant-selects > div > div > select");
    if (varSelect) varSelect.value = varValue;
    
    if (document.querySelector('.template--gift')) {
      const priceItem = document.querySelector('.mobile-stick-sub .price-item.price-item--regular');
      if (priceItem) priceItem.innerHTML = varValue;
    }
  });
}
// END validation submit continued

// stop hover
const bar = document.querySelector('.card.card--standard.card--media.ezsd-root.ezsd-root--interacted');
if (bar) {
  bar.addEventListener('mousemove', function () {
    preventDefault();
  });
}

// Initial dropdown
const initialDropdownContainers = document.querySelectorAll('.product-form__initial');
initialDropdownContainers.forEach(function(container) {
  const initialDropdownButton = container.querySelector('.product-form__initial-button');
  const initialDropdownButtonSpan = container.querySelector('.product-form__initial-button span');
  const initialDropdownOptions = container.querySelector('.product-form__initial-options');
  const initialDropdownOption = container.querySelectorAll('.product-form__initial-option');
  const initialDropdownValidation = container.querySelector('.prod-validation');
  
  if (initialDropdownButton && initialDropdownOptions) {
    initialDropdownButton.addEventListener('click', function () {
      initialDropdownOptions.classList.toggle('hidden');
      initialDropdownButton.classList.toggle('open');
    });
    
    document.addEventListener('click', function(event) {
      if (!initialDropdownButton.contains(event.target) && !initialDropdownOptions.contains(event.target)) {
        initialDropdownOptions.classList.add('hidden');
        initialDropdownButton.classList.remove('open');
      }
    });
  }
  
  if (initialDropdownOption.length > 0) {
    initialDropdownOption.forEach(function(option) {
      option.addEventListener('click', function () {
        const allInitialProperties = document.querySelectorAll('.product-form__initial-property');
        const allInitialButtons = document.querySelectorAll('.product-form__initial-button');
        const allInitialButtonSpans = document.querySelectorAll('.product-form__initial-button span');
        const allInitialOptions = document.querySelectorAll('.product-form__initial-option');
        const allInitialValidations = document.querySelectorAll('.product-form__initial .prod-validation');
        
        allInitialOptions.forEach(function(opt) {
          opt.classList.remove('active');
        });
        
        allInitialOptions.forEach(function(opt) {
          if (opt.value === option.value) {
            opt.classList.add('active');
          }
        });
        
        allInitialButtons.forEach(function(btn) {
          btn.value = option.value;
        });
        
        allInitialButtonSpans.forEach(function(span) {
          span.innerHTML = option.value;
        });
        
        allInitialProperties.forEach(function(property) {
          property.value = option.value;
        });
        
        initialDropdownOptions.classList.add('hidden');
        initialDropdownButton.classList.remove('open');
        
        allInitialValidations.forEach(function(validation) {
          validation.classList.add('hidden');
        });
      });
    });
  }
});

// Engraving module validation hide on save
const engravingCloseButton = document.querySelector('.engraving-module__close-button');
if (engravingCloseButton) {
  engravingCloseButton.addEventListener('click', function() {
    const engravingValidation = document.querySelector('.engraving-module__wrapper .prod-validation');
    const engravingInput = document.querySelector('.engraving-module__input');
    
    if (engravingValidation && engravingInput && engravingInput.value.trim() !== "") {
      engravingValidation.classList.add('hidden');
    }
  });
}

// Sync product terms checkboxes
const productTermsCheckboxes = document.querySelectorAll('.product-terms__checkbox');
productTermsCheckboxes.forEach(function(checkbox) {
  checkbox.addEventListener('change', function() {
    productTermsCheckboxes.forEach(function(other) {
      other.checked = checkbox.checked;
    });
  });
});

// Mobile stick sub
const mobileStickSub = document.querySelector('.mobile-stick-sub');
const productFormButtons = document.querySelector('.product-form__buttons-add-to-cart--desktop');

if (mobileStickSub && productFormButtons) {
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        mobileStickSub.classList.add('hidden');
      } else {
        mobileStickSub.classList.remove('hidden');
      }
    });
  });
  
  observer.observe(productFormButtons);
}
